import { createSlice } from '@reduxjs/toolkit';

export const tenancySlice = createSlice({
    name: 'tenancy',
    initialState: {
        tenancyId: '',
        tenancyName: '',
        isHierarchyTenancy: false,
        tenancyLookup: {},
        featureSwitches: null,
        featureSwitchesLoading: true,
        tenancyBasics: null,
        tenancyBasicsLoading: true,
    },
    reducers: {
        setTenancyId: (state, action) => {
            state.tenancyId = action.payload;
        },
        setTenancyName: (state, action) => {
            state.tenancyName = action.payload;
        },
        setIsHierarchyTenancy: (state, action) => {
            state.isHierarchyTenancy = action.payload;
        },
        setTenancyLookup: (state, action) => {
            state.tenancyLookup = action.payload;
        },
        setFeatureSwitches: (state, action) => {
            state.featureSwitches = action.payload;
            state.featureSwitchesLoading = false;
        },
        setFeatureSwitchesLoading: (state, action) => {
            state.featureSwitchesLoading = action.payload;
        },
        setTenancyBasics: (state, action) => {
            state.tenancyBasics = action.payload;
            state.tenancyBasicsLoading = false;
        },
        setTenancyBasicsLoading: (state, action) => {
            state.tenancyBasicsLoading = action.payload;
        },
    },
});

export const {
    setTenancyId,
    setTenancyName,
    setIsHierarchyTenancy,
    setTenancyLookup,
    setFeatureSwitches,
    setFeatureSwitchesLoading,
    setTenancyBasics,
    setTenancyBasicsLoading
} = tenancySlice.actions;

export default tenancySlice.reducer;